import styled from '@emotion/styled';

const FlexContainer = styled.div`
  margin-top: 11px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  > div {
    flex: 50% 0 0;
    max-width: calc(50% - 8px);
  }
`;
export default FlexContainer;